// @ts-nocheck
import React from 'react';
import PriceCellEditable from './PriceCellEditable';
import PriceCellReadOnly from './PriceCellReadOnly';

function PriceCell({
  currency,
  skuPrice,
  skuDraftPrice,
  game,
  editable,
  showDraft,
  onChange,
  saving,
  locked,
  className,
  onCursor,
}) {
  return editable ? (
    <PriceCellEditable
      currency={currency}
      skuPrice={skuPrice}
      skuDraftPrice={skuDraftPrice}
      game={game}
      showDraft={showDraft}
      onChange={onChange}
      saving={saving}
      locked={locked}
      className={className}
      onCursor={onCursor}
    />
  ) : (
    <PriceCellReadOnly
      currency={currency}
      skuPrice={skuPrice}
      skuDraftPrice={skuDraftPrice}
      game={game}
      showDraft={showDraft}
    />
  );
}



export default PriceCell;
